import React from 'react';
import { SvgIcon } from '@material-ui/core';

const ToBackIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 30 30">
      <g clipPath="url(#clip0_13_76)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.23405 21.7291L9.78408 20.3773C9.95139 20.448 10.136 20.4878 10.3333 20.4878H11.6496V21.9512H10.3333C9.94395 21.9512 9.57266 21.8722 9.23405 21.7291ZM24.812 21.9512V20.4878H26.1282C26.3256 20.4878 26.5102 20.448 26.6775 20.3773L27.2275 21.7291C26.8889 21.8722 26.5176 21.9512 26.1282 21.9512H24.812ZM29 4.26829H27.5641V2.92683C27.5641 2.72571 27.5251 2.53756 27.4557 2.36704L28.7821 1.80648C28.9225 2.15157 29 2.52998 29 2.92683V4.26829ZM11.6496 0H10.3333C9.94395 0 9.57266 0.0789838 9.23405 0.222089L9.78408 1.57388C9.95139 1.50317 10.136 1.46341 10.3333 1.46341H11.6496V0ZM7.46155 17.6829H8.89745V19.0244C8.89745 19.2255 8.93646 19.4137 9.00584 19.5842L7.67946 20.1447C7.53905 19.7996 7.46155 19.4212 7.46155 19.0244V17.6829ZM7.46155 15H8.89745V12.3171H7.46155V15ZM7.46155 9.63415H8.89745V6.95122H7.46155V9.63415ZM7.46155 4.26829H8.89745V2.92683C8.89745 2.72571 8.93646 2.53756 9.00584 2.36704L7.67946 1.80647C7.53905 2.15157 7.46155 2.52998 7.46155 2.92683V4.26829ZM14.2821 0V1.46341H16.9145V0H14.2821ZM19.547 0V1.46341H22.1795V0H19.547ZM24.812 0V1.46341H26.1282C26.3256 1.46341 26.5102 1.50317 26.6775 1.57388L27.2275 0.22209C26.8889 0.0789839 26.5176 0 26.1282 0H24.812ZM29 6.95122H27.5641V9.63415H29V6.95122ZM29 12.3171H27.5641V15H29V12.3171ZM29 17.6829H27.5641V19.0244C27.5641 19.2255 27.5251 19.4137 27.4557 19.5842L28.7821 20.1447C28.9225 19.7997 29 19.4212 29 19.0244V17.6829ZM22.1795 21.9512V20.4878H19.547V21.9512H22.1795ZM16.9145 21.9512V20.4878H14.2821V21.9512H16.9145Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 26.3415V5.85367H2.4359V26.3415C2.4359 27.5538 3.40021 28.5366 4.58974 28.5366H23.2564V30H4.58974C2.60718 30 1 28.362 1 26.3415Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_13_76">
          <rect width="30" height="30" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default ToBackIcon;
